<!-- [tooltip]="tooltip" content-type="template" pointerEvents="auto" show-delay="1000" hide-delay="600" theme="light" -->
<div class="event-container">

    <div class="event-content" [ngClass]="cardClass" [ngStyle]="cardStyle" [tooltip]="tooltip" content-type="template" pointerEvents="auto" show-delay="1000" hide-delay="600" theme="light">

        <ng-container *ngIf="allocation?.overhead; then overheadTemplate; else allocationTemplate"></ng-container>

        <ng-template #overheadTemplate>
            <div class="job">{{allocation?.overhead?.name}} </div>
        </ng-template>

        <ng-template #allocationTemplate>

            <div class="color">
                <span class="complete"><i class="fa fa-check"></i></span>
                <div class="tag" [ngStyle]="colorTagStyle">{{$safeNavigationMigration((allocation | cardColorValue:view)?.name) | displayText }}</div>
                @if(allocation?.isConflict){
                <div style="margin-left: auto;"><i class="fa-regular fa-calendar-circle-exclamation" style="color: var(--colors-background-danger)"></i></div>
                }
            </div>

            <div class="job">{{allocation?.workOrder?.name ?? allocation?.opportunity?.name}} </div>
            <div class="time">{{$safeNavigationMigration(allocation?.startDate) | timezoneTime:timezone:'h:mma'}} - {{allocation.endDate | timezoneTime:timezone:'h:mma'}}</div>
            <div class="address" *ngIf="allocation?.meta?.site?.address">{{$safeNavigationMigration(allocation?.meta?.site?.address) | displayText}}</div>


            <div class="meta" *ngIf="allocation?.meta?.customer">{{$safeNavigationMigration(allocation?.meta?.customer) | displayText }}</div>
            <div class="meta" *ngIf="allocation?.meta?.customerWO">{{$safeNavigationMigration(allocation?.meta?.customerWO) | displayText }}</div>

            <div class="tags">
                <div class="tag" *ngFor="let tag of allocation?.meta?.tags" [ngStyle]="{'background-color': tag.color, 'color': tag.color | textColor}">
                    {{tag?.name}}
                </div>
            </div>


        </ng-template>

        <div class="info">
            <div class="left">
                <i *ngIf="isShadow; else allocationSource" class="fa fa-truck"></i>
                <ng-template #allocationSource>
                    <i class="fa" [ngClass]="$safeNavigationMigration(allocation?.source) | sourceIcon"></i>
                </ng-template>
            </div>
        </div>

    </div>

    <div [ngClass]="{'booking-status': showDashed}" [ngStyle]="cardBottomStyle">
    </div>
</div>

<ng-template #tooltip>

    <ng-container *ngIf="allocation?.overhead; then overheadTemplate; else jobTemplate"></ng-container>
    <ng-template #overheadTemplate>
        <div class="list-item">
            <div class="content-area">
                <div class="content-info">{{allocation?.overhead?.name}}</div>
                <div class="content-note">{{allocation?.note}}</div>
            </div>
        </div>
    </ng-template>
    <ng-template #jobTemplate>
        <div class="list-item">
            <div class="content-area">
                <div class="content-info flex-row">
                    <span class="flex-fill">{{allocation?.workOrder?.name ?? allocation?.opportunity?.name}} - </span>
                    <span class="flex-auto">{{allocation?.status }}</span>
                </div>
                <div class="content-address">{{allocation?.meta?.site?.address}}</div>

                <div class="content-contact">
                    <div>
                        <i class="fa fa-address-card"></i> {{$safeNavigationMigration(allocation?.meta?.site?.contactName) | displayText}}
                    </div>
                    <div>
                        <i class="fa fa-phone"></i> {{$safeNavigationMigration(allocation?.meta?.site?.contactPhone) | displayText}}
                    </div>
                </div>
                <div *ngIf="allocation?.note" class="content-note">{{allocation?.note}}</div>
            </div>
        </div>
    </ng-template>


</ng-template>